import React from "react";

const FilledChevronUp = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 8l6 6H6l6-6z" />
  </svg>
);

const FilledChevronDown = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 16l-6-6h12l-6 6z" />
  </svg>
);

// labelSuffix renders between the label and the sort arrows — used for a
// per-column info tooltip (see Pricing Template's "Final Result Rule").
const SortableHeader = ({ label, field, sortField, sortOrder, handleSort, sortable=true, classes="", style={}, innerRef, resizeHandle=null, labelSuffix=null }) => {
  return (
    <th ref={innerRef} style={{ cursor: "pointer", ...style }} className={classes}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          // Keeps the sort arrows clear of the resize handle, which sits at
          // right:0 with a grip mark 3px in. Without it a long label pushes the
          // arrows to the cell edge and the grip draws straight through them.
          paddingRight: 8,
          fontFamily: "Montserrat",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          color: "var(--Gray-900, #212529)",
        }}
      >
        {label}

        {labelSuffix ? <span style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>{labelSuffix}</span> : null}

       {/* flexShrink: 0 — without it a long header label squeezes the sort icon
           to zero width and the th's overflow:hidden clips it out of sight. */}
       {sortable?( <span onClick={() => handleSort(field)} style={{ display: "flex", flexDirection: "column", justifyContent: "center", flexShrink: 0 }}>
          <div  class="sorticon" style={{ lineHeight: 0 }}>
            <FilledChevronUp
           
              size={12}
              color={sortField === field && sortOrder === "asc" ? "black" : "#6C757D"}
            />
          </div>
          <div class="sorticon" style={{ lineHeight: 0, marginTop: -12}}>
            <FilledChevronDown
            
              size={12}
              color={sortField === field && sortOrder === "desc" ? "black" : "#6C757D"}
            />
          </div>
        </span>):""}
      </span>
      {resizeHandle}
    </th>
  );
};

export default SortableHeader;